import React from 'react';
import { Section } from '../components/Section';
import { FeatureList } from '../components/FeatureList';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { FAQItem } from '../components/FAQItem';
import { GuaranteeBox } from '../components/GuaranteeBox';
import { Footer } from '../components/Footer';
import { PricingBox } from '../components/PricingBox';
import { SalesNotification } from '../components/SalesNotification';
import { HeartIcon, SparklesIcon, FlowerIcon, TestTubeIcon, Clock } from 'lucide-react';
export function SalesPage() {
  const handleCTAClick = () => {
    // Add purchase link here
    console.log('CTA clicked');
  };
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta-especial');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="min-h-screen bg-[#FAF7F2]" data-id="element-112">
      {/* Sales Notification - Mobile Only */}
      <SalesNotification data-id="element-113" />

      {/* Hero Section */}
      <Section background="cream" className="pt-16 pb-16" data-id="element-114">
        <div className="text-center" data-id="element-115">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#8B7355] mb-8 leading-tight" data-id="element-116">
            La Guía Que Todas Las Mujeres Están Comprando: Soluciones Rápidas,
            Naturales y Baratas Para Tu Hogar.
          </h1>

          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1ijejMRnwm7RVrEqfusc1u/secretos-abuela-fondo-crema.png" alt="Los Secretos de la Abuela" className="w-full max-w-md mx-auto mb-8" data-id="element-117" />

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#8B7355] mb-6 leading-tight" data-id="element-118">
            El Manual de Supervivencia para Tu Hogar
          </h2>

          <p className="text-xl md:text-2xl text-[#3A3226] mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-119">
            Una guía práctica, tierna y poderosa para sanar, limpiar y vivir
            mejor con lo que ya tienes en casa.
          </p>
        </div>
      </Section>

      {/* Opening Letter */}
      <Section background="white" data-id="element-120">
        <div className="prose prose-lg max-w-none" data-id="element-121">
          <h2 className="text-3xl md:text-4xl font-bold text-[#D4AF37] mb-6 flex items-center gap-3" data-id="element-122">
            <HeartIcon className="w-8 h-8" data-id="element-123" />
            Querida hija…
          </h2>

          <p className="text-lg leading-relaxed mb-4" data-id="element-124">
            Ay, mi amor… ven, siéntate un momentico aquí a mi lado.
          </p>

          <p className="text-lg leading-relaxed mb-4" data-id="element-125">Respira.</p>
          <p className="text-lg leading-relaxed mb-4" data-id="element-126">Relájate.</p>

          <p className="text-lg leading-relaxed mb-6" data-id="element-127">
            Déjame contarte algo que tu bisabuela le dijo a tu abuela, y tu
            abuela me dijo a mí, y ahora yo te digo a ti, con el mismo amor de
            siempre:
          </p>

          <blockquote className="text-2xl font-serif italic text-[#8B7355] border-l-4 border-[#D4AF37] pl-6 my-8" data-id="element-128">
            "Si esto funcionó por generaciones… ¿por qué no hoy?"
          </blockquote>

          <p className="text-lg leading-relaxed mb-4" data-id="element-129">
            Porque mientras allá afuera el mundo se acelera, la vida se
            complica, la ansiedad sube, las pantallas nos chupan la energía y
            los productos de supermercado se hacen más caros y más tóxicos cada
            año...
          </p>

          <p className="text-lg leading-relaxed mb-6" data-id="element-130">
            Aquí adentro, dentro de tu hogar, todavía existe un refugio.
          </p>

          <p className="text-lg leading-relaxed" data-id="element-131">
            Una forma más simple de vivir.
          </p>
          <p className="text-lg leading-relaxed" data-id="element-132">Más humana.</p>
          <p className="text-lg leading-relaxed" data-id="element-133">Más bonita.</p>
          <p className="text-lg leading-relaxed mb-6" data-id="element-134">Más nuestra.</p>

          <p className="text-lg leading-relaxed mb-6" data-id="element-135">
            Y ese refugio está hecho con cosas que tú ya tienes en casa.
          </p>

          <div className="text-center my-8 space-y-2" data-id="element-136">
            <p className="text-xl font-medium" data-id="element-137">Vicks.</p>
            <p className="text-xl font-medium" data-id="element-138">Vinagre.</p>
            <p className="text-xl font-medium" data-id="element-139">Bicarbonato.</p>
            <p className="text-xl font-medium" data-id="element-140">Hierbitas.</p>
            <p className="text-xl font-medium" data-id="element-141">Cebolla.</p>
            <p className="text-xl font-medium" data-id="element-142">Agüita tibia.</p>
            <p className="text-xl font-medium" data-id="element-143">Amor.</p>
            <p className="text-xl font-medium text-[#D4AF37]" data-id="element-144">Y sabiduría.</p>
          </div>

          <div className="text-center mt-8" data-id="element-145">
            <button onClick={scrollToOffer} className="bg-[#D4AF37] hover:bg-[#C4A027] text-white px-8 py-4 rounded-full text-lg font-semibold transition-all hover:scale-105 active:scale-95 shadow-lg" data-id="element-146">
              Descubre cómo
            </button>
          </div>
        </div>
      </Section>

      {/* 3. Problem & Solution Section */}
      <Section background="beige" data-id="element-147">
        <h2 className="text-3xl md:text-4xl font-bold text-[#8B7355] mb-6 flex items-center gap-3" data-id="element-148">
          <FlowerIcon className="w-8 h-8 text-[#D4AF37]" data-id="element-149" />
          La vida moderna te tiene agotada, ¿verdad?
        </h2>

        <p className="text-lg leading-relaxed mb-4" data-id="element-150">
          Mira, mi niña… tú y yo sabemos que la vida hoy no es fácil.
        </p>

        <div className="space-y-2 my-6" data-id="element-151">
          <p className="text-lg" data-id="element-152">Sales a trabajar.</p>
          <p className="text-lg" data-id="element-153">Cuidas a tus hijos.</p>
          <p className="text-lg" data-id="element-154">Limpias.</p>
          <p className="text-lg" data-id="element-155">Cocinas.</p>
          <p className="text-lg" data-id="element-156">Luchas con miles de tareas.</p>
          <p className="text-lg" data-id="element-157">Te queda poco tiempo para ti.</p>
          <p className="text-lg font-medium" data-id="element-158">Y menos aún, para respirar.</p>
        </div>

        <p className="text-lg leading-relaxed mb-4" data-id="element-159">
          Te bombardean con anuncios diciendo:
        </p>

        <div className="bg-white/50 p-6 rounded-lg my-6 space-y-2" data-id="element-160">
          <p className="text-lg italic" data-id="element-161">"Compra este producto milagroso."</p>
          <p className="text-lg italic" data-id="element-162">"Compra este limpiador tóxico."</p>
          <p className="text-lg italic" data-id="element-163">"Compra esta pastilla."</p>
          <p className="text-lg italic" data-id="element-164">"Compra este perfume."</p>
          <p className="text-lg italic font-bold" data-id="element-165">"Compra, compra, compra…"</p>
        </div>

        <p className="text-lg leading-relaxed mb-4" data-id="element-166">Pero ¿sabes qué pasa?</p>

        <p className="text-lg leading-relaxed mb-4" data-id="element-167">
          Entre más compras… más cansada estás.
        </p>

        <p className="text-lg leading-relaxed mb-6" data-id="element-168">
          Entre más químicos usas… menos tranquila te sientes.
        </p>

        <p className="text-lg leading-relaxed font-medium" data-id="element-169">
          Porque nada te da esa paz que da el hogar de la abuela:
        </p>

        <p className="text-xl text-center my-6 text-[#8B7355] italic" data-id="element-170">
          limpio, oloroso, cálido, con soluciones para todo, siempre listas,
          siempre amorosas.
        </p>
      </Section>

      {/* Solution Introduction */}
      <Section background="white" data-id="element-171">
        <h2 className="text-3xl md:text-4xl font-bold text-[#D4AF37] mb-6 flex items-center gap-3" data-id="element-172">
          <SparklesIcon className="w-8 h-8" data-id="element-173" />
          Te presento… LOS SECRETOS DE LA ABUELA
        </h2>

        <h3 className="text-2xl font-serif italic text-[#8B7355] mb-8" data-id="element-174">
          Cómo Vicks, Vinagre y Remedios Caseros se convirtieron en el Manual de
          Supervivencia para tu Hogar.
        </h3>

        <p className="text-lg leading-relaxed mb-4" data-id="element-175">
          Este libro no es un libro.
        </p>

        <p className="text-lg leading-relaxed" data-id="element-176">Es un abrazo.</p>
        <p className="text-lg leading-relaxed" data-id="element-177">Un hogar.</p>
        <p className="text-lg leading-relaxed mb-6" data-id="element-178">
          Un manual práctico, cariñoso y poderoso para cuidar tu salud, tu casa
          y tu mente con soluciones que siempre han funcionado.
        </p>

        <p className="text-lg leading-relaxed font-medium mb-4" data-id="element-179">
          Y ahora — escucha bien — respaldadas por ciencia moderna.
        </p>

        <p className="text-lg leading-relaxed italic" data-id="element-180">
          Porque sí, hijita… la abuela también se actualiza.
        </p>
      </Section>

      {/* 4. What's Inside / How It Works */}
      <Section background="cream" data-id="element-181">
        <h2 className="text-3xl md:text-4xl font-bold text-[#8B7355] mb-8 flex items-center gap-3" data-id="element-182">
          <FlowerIcon className="w-8 h-8 text-[#D4AF37]" data-id="element-183" />
          ¿Qué encontrarás dentro?
        </h2>

        <FeatureList items={['Más de 50 remedios naturales — Para resfriados, dolor muscular, estrés, ansiedad, indigestión, insomnio y más.', 'Más de 10 recetas de limpieza sin químicos — Para cocina, baño, ropa, pisos, ventanas, olores, manchas… TODO.', 'Usos sorprendentes del Vicks (20+ remedios) — Desde descongestión hasta migrañas, pies cansados, granitos… y truquitos que te van a encantar.', '30 usos del vinagre — Para limpiar, desinfectar, suavizar, eliminar moho, quitar sarro, aromatizar…', '25 usos del bicarbonato — Para olores, manchas, limpieza profunda, belleza y bienestar.', '10 combinaciones mágicas — Que parecen "brujería blanca" pero tienen base científica.', 'Checklists, planes semanales y guías imprimibles — Para que organices tu hogar y tu bienestar sin estrés.', 'Historias reales que te harán reír — Porque la vida con abuela siempre es divertida.']} data-id="element-184" />
      </Section>

      {/* 5. Transformation Testimonials */}
      <Section background="white" data-id="element-185">
        <h2 className="text-3xl md:text-4xl font-bold text-[#D4AF37] mb-8" data-id="element-186">
          Tu hogar cambiará para siempre
        </h2>

        <p className="text-xl mb-6" data-id="element-187">Imagina…</p>

        <FeatureList items={['Una casa limpia sin químicos.', 'Gastar menos en productos industriales.', 'Aromas frescos y naturales.', 'Soluciones para cualquier emergencia.', 'Menos ansiedad y más calma.', 'Más conexión con tus hijos y tu herencia latina.', 'Un hogar que se siente seguro, cálido y confiable.']} data-id="element-188" />

        <p className="text-xl text-center font-semibold mt-8 mb-12" data-id="element-189">
          Todo eso y más… usando lo que ya tienes.
        </p>

        {/* Testimonials */}
        <div className="grid md:grid-cols-2 gap-6 mt-12" data-id="element-190">
          <TestimonialCard name="María González" location="Miami, FL" text="Este libro cambió mi vida. Ya no gasto fortunas en productos de limpieza y mi casa huele increíble. Los remedios para el resfriado de mis hijos funcionan mejor que cualquier medicina." data-id="element-191" />
          <TestimonialCard name="Carmen Rodríguez" location="Los Angeles, CA" text="Finalmente encontré las recetas que mi abuela usaba. Ahora puedo enseñarle a mi hija todo lo que yo aprendí. Es como tener a la abuela en casa otra vez." data-id="element-192" />
          <TestimonialCard name="Rosa Martínez" location="Houston, TX" text="Los trucos del Vicks son increíbles. Nunca imaginé que podía usarlo para tantas cosas. Y el vinagre... ¡es mágico! Mi casa brilla sin químicos tóxicos." data-id="element-193" />
          <TestimonialCard name="Ana López" location="Chicago, IL" text="Compré el libro por curiosidad y ahora no puedo vivir sin él. Cada semana descubro algo nuevo. Mis amigas me preguntan cuál es mi secreto y yo les digo: ¡la abuela!" data-id="element-194" />
        </div>
      </Section>

      {/* 6. Expert or Influencer Endorsement */}
      <Section background="beige" data-id="element-195">
        <h2 className="text-3xl md:text-4xl font-bold text-[#8B7355] mb-6 flex items-center gap-3" data-id="element-196">
          <TestTubeIcon className="w-8 h-8 text-[#D4AF37]" data-id="element-197" />
          La Ciencia Confirma lo que la Abuela Sabía
        </h2>

        <p className="text-lg leading-relaxed mb-6" data-id="element-198">
          El libro te explica (con humor) cosas como:
        </p>

        <div className="space-y-4 bg-white p-6 rounded-lg" data-id="element-199">
          <p className="text-lg" data-id="element-200">
            <span className="font-semibold" data-id="element-201">El vinagre</span> contiene ácido
            acético → mata bacterias y disuelve minerales
          </p>
          <p className="text-lg" data-id="element-202">
            <span className="font-semibold" data-id="element-203">El bicarbonato</span> es alcalino →
            neutraliza olores y actúa como exfoliante suave
          </p>
          <p className="text-lg" data-id="element-204">
            <span className="font-semibold" data-id="element-205">El Vicks</span> contiene mentol y
            alcanfor → abre vías respiratorias y relaja músculos
          </p>
        </div>

        <p className="text-xl text-center my-8 font-medium text-[#8B7355]" data-id="element-206">
          Tu abuela no sabía esos nombres complicados,
        </p>

        <p className="text-2xl text-center font-bold text-[#D4AF37]" data-id="element-207">
          pero sí sabía una cosa:
        </p>

        <p className="text-3xl text-center my-6 font-serif italic" data-id="element-208">
          Funcionan.
        </p>

        <p className="text-2xl text-center font-bold" data-id="element-209">Y punto.</p>
      </Section>

      {/* Why Different */}
      <Section background="white" data-id="element-210">
        <h2 className="text-3xl md:text-4xl font-bold text-[#8B7355] mb-6" data-id="element-211">
          ¿Por qué este libro es diferente?
        </h2>

        <div className="space-y-3 mb-8" data-id="element-212">
          <p className="text-lg" data-id="element-213">No es un blog con recetas sueltas.</p>
          <p className="text-lg" data-id="element-214">No es un PDF genérico sin alma.</p>
          <p className="text-lg" data-id="element-215">No es otro curso frío y técnico.</p>
          <p className="text-lg" data-id="element-216">
            No es una lista de trucos copiada de TikTok.
          </p>
        </div>

        <p className="text-xl font-semibold mb-6" data-id="element-217">
          Es la primera guía latina que combina:
        </p>

        <div className="grid md:grid-cols-2 gap-4 my-8" data-id="element-218">
          <div className="bg-[#FAF7F2] p-6 rounded-lg" data-id="element-219">
            <p className="text-lg font-medium" data-id="element-220">Sabiduría de abuelita</p>
          </div>
          <div className="bg-[#FAF7F2] p-6 rounded-lg" data-id="element-221">
            <p className="text-lg font-medium" data-id="element-222">Humor y calidez</p>
          </div>
          <div className="bg-[#FAF7F2] p-6 rounded-lg" data-id="element-223">
            <p className="text-lg font-medium" data-id="element-224">Ciencia moderna</p>
          </div>
          <div className="bg-[#FAF7F2] p-6 rounded-lg" data-id="element-225">
            <p className="text-lg font-medium" data-id="element-226">Limpieza práctica</p>
          </div>
          <div className="bg-[#FAF7F2] p-6 rounded-lg" data-id="element-227">
            <p className="text-lg font-medium" data-id="element-228">Remedios caseros reales</p>
          </div>
          <div className="bg-[#FAF7F2] p-6 rounded-lg" data-id="element-229">
            <p className="text-lg font-medium" data-id="element-230">Cuidado emocional</p>
          </div>
        </div>

        <p className="text-lg leading-relaxed text-center italic" data-id="element-231">
          Todo contado como solo una abuela puede contarlo:
        </p>
        <p className="text-xl text-center font-semibold text-[#D4AF37] mt-2" data-id="element-232">
          simple, directo, útil y con mucho amor.
        </p>
      </Section>

      {/* Fear of Loss */}
      <Section background="cream" data-id="element-233">
        <h2 className="text-3xl md:text-4xl font-bold text-[#8B7355] mb-6" data-id="element-234">
          Pero mi niña… ¿qué pasa si estas tradiciones se pierden?
        </h2>

        <p className="text-lg leading-relaxed mb-4" data-id="element-235">
          Ese es mi mayor miedo, hijita.
        </p>

        <p className="text-lg leading-relaxed mb-4" data-id="element-236">
          Que una generación entera crezca sin saber lo que nuestras abuelas
          sabían.
        </p>

        <div className="space-y-2 my-6" data-id="element-237">
          <p className="text-lg" data-id="element-238">Que se pierda esa magia.</p>
          <p className="text-lg" data-id="element-239">Ese amor.</p>
          <p className="text-lg" data-id="element-240">Ese ingenio.</p>
          <p className="text-lg" data-id="element-241">Ese orgullo latino.</p>
          <p className="text-lg font-medium" data-id="element-242">
            Esa sabiduría que nos salvó, nos cuidó, nos acompañó.
          </p>
        </div>

        <p className="text-xl font-semibold mb-4" data-id="element-243">
          Por eso escribí este libro:
        </p>

        <p className="text-lg leading-relaxed mb-2" data-id="element-244">
          para que no se pierda jamás.
        </p>
        <p className="text-lg leading-relaxed mb-2" data-id="element-245">
          Para que tú tengas tu propio Manual de Supervivencia de la Abuela
          Moderna.
        </p>
        <p className="text-lg leading-relaxed mb-2" data-id="element-246">
          Para que tus hijos lo tengan.
        </p>
        <p className="text-lg leading-relaxed" data-id="element-247">Y tus nietos también.</p>
      </Section>

      {/* Who It's For */}
      <Section background="white" data-id="element-248">
        <h2 className="text-3xl md:text-4xl font-bold text-[#D4AF37] mb-8" data-id="element-249">
          Este libro es para ti si…
        </h2>

        <FeatureList items={['Quieres un hogar más natural', 'Te gusta lo práctico', 'Te encanta la tradición latina', 'Extrañas los consejos de tu abuela', 'Quieres gastar menos', 'Quieres cuidar tu salud y la de tu familia', 'Quieres sentirte más segura y organizada', 'Necesitas soluciones rápidas para el día a día']} data-id="element-250" />
      </Section>

      {/* 7. Offer & Bonuses Section */}
      <Section background="beige" id="oferta-especial" data-id="element-251">
        <h2 className="text-3xl md:text-4xl font-bold text-[#8B7355] mb-12 text-center" data-id="element-252">
          🎁 Tu Oferta Especial
        </h2>

        <div className="text-center mb-12" data-id="element-253"></div>

        <PricingBox onCTAClick={handleCTAClick} data-id="element-254" />

        <div className="mt-16" data-id="element-255">
          <GuaranteeBox data-id="element-256" />
        </div>

        <div className="mt-12 text-center" data-id="element-257"></div>
      </Section>

      {/* Pre-CTA */}
      <Section background="cream" data-id="element-258">
        <h2 className="text-3xl md:text-4xl font-bold text-[#8B7355] mb-6" data-id="element-259">
          Antes de comprar otro químico caro…
        </h2>

        <div className="space-y-4 text-xl" data-id="element-260">
          <p data-id="element-261">lee este libro.</p>
          <p data-id="element-262">Antes de gastar en productos industriales…</p>
          <p className="font-semibold" data-id="element-263">lee este libro.</p>
          <p data-id="element-264">Antes de sentirte mal por no "saber qué hacer"…</p>
          <p className="font-bold text-[#D4AF37]" data-id="element-265">lee este libro.</p>
        </div>

        <p className="text-lg leading-relaxed mt-8 mb-4" data-id="element-266">Te prometo algo:</p>

        <p className="text-xl text-center font-medium italic" data-id="element-267">
          Cuando termines de leerlo, vas a mirar tu botiquín y tu cocina con
          otros ojos.
        </p>

        <p className="text-xl text-center font-semibold mt-4" data-id="element-268">
          Y vas a sonreír con orgullo.
        </p>
      </Section>

      {/* 9. FAQ Section */}
      <Section background="white" data-id="element-269">
        <h2 className="text-3xl md:text-4xl font-bold text-[#8B7355] mb-8 text-center" data-id="element-270">
          Preguntas Frecuentes
        </h2>

        <div className="max-w-2xl mx-auto bg-[#FAF7F2] rounded-xl p-6 md:p-8" data-id="element-271">
          <FAQItem question="¿Cómo recibo el libro?" answer="Inmediatamente después de tu compra, recibirás un email con el enlace de descarga. Puedes leerlo en tu computadora, tablet o teléfono. Es instantáneo." data-id="element-272" />
          <FAQItem question="¿El libro está en español?" answer="Sí, completamente en español. Escrito con el cariño y el lenguaje de nuestras abuelas latinas." data-id="element-273" />
          <FAQItem question="¿Funciona la garantía de reembolso?" answer="Absolutamente. Si en 30 días sientes que el libro no te ayudó, te devolvemos tu dinero completo. Sin preguntas, sin complicaciones." data-id="element-274" />
          <FAQItem question="¿Necesito ingredientes especiales?" answer="No. Todo lo que necesitas ya lo tienes en casa: Vicks, vinagre, bicarbonato, hierbas comunes. Nada caro ni difícil de conseguir." data-id="element-275" />
          <FAQItem question="¿Es solo para limpiar o también para salud?" answer="Ambos. El libro incluye más de 50 remedios naturales para salud (resfriados, dolores, estrés) y más de 10 recetas de limpieza sin químicos." data-id="element-276" />
          <FAQItem question="¿Puedo imprimirlo?" answer="Sí, puedes imprimir el libro completo o solo las páginas que necesites. También incluye checklists y guías diseñadas para imprimir." data-id="element-277" />
        </div>
      </Section>

      {/* 10. Final CTA with urgency */}
      <Section background="beige" data-id="element-278">
        <h2 className="text-3xl md:text-4xl font-bold text-[#D4AF37] mb-8 text-center" data-id="element-279">
          💙 Mi amor… llegó el momento
        </h2>

        <p className="text-xl text-center mb-6 italic" data-id="element-280">
          Tu abuela moderna te dice:
        </p>

        <blockquote className="text-2xl font-serif text-center text-[#8B7355] my-8" data-id="element-281">
          "Haz tu vida más fácil.
          <br data-id="element-282" />
          Haz tu hogar más bonito.
          <br data-id="element-283" />
          Aprende lo que siempre te quise enseñar."
        </blockquote>

        <div className="bg-white border-2 border-[#D4AF37] rounded-xl p-6 mb-8 text-center" data-id="element-284">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-285">
            <Clock className="w-6 h-6 text-[#D4AF37]" data-id="element-286" />
            <p className="text-lg font-bold text-[#8B7355]" data-id="element-287">
              Precio especial termina pronto
            </p>
          </div>
          <p className="text-[#3A3226]" data-id="element-288">
            El precio subirá a $47 cuando termine esta promoción. Aprovecha
            ahora.
          </p>
        </div>

        <CTAButton onClick={handleCTAClick} className="mb-8" data-id="element-289" />

        <h3 className="text-2xl font-bold text-center mb-6" data-id="element-290">
          LOS SECRETOS DE LA ABUELA
        </h3>

        <div className="text-center space-y-2 text-lg" data-id="element-291">
          <p data-id="element-292">Tu hogar…</p>
          <p data-id="element-293">tu bienestar…</p>
          <p data-id="element-294">tu historia…</p>
          <p className="font-bold text-[#D4AF37] text-xl mt-4" data-id="element-295">
            te lo van a agradecer.
          </p>
        </div>

        <div className="mt-8 text-center" data-id="element-296">
          <a href="https://impactlifemethod.com/cart/48185238814944:1" className="inline-block bg-[#D4AF37] hover:bg-[#C4A027] text-white px-8 py-4 rounded-full text-xl font-bold transition-all hover:scale-105 active:scale-95 shadow-lg" data-id="element-297">
            Sí, lo quiero AHORA
          </a>
        </div>
      </Section>

      {/* 11. Compliance / Legal Footer */}
      <Footer data-id="element-298" />
    </div>;
}